
import Remofilwe from "../assets/Remofilwe.jpg";

import Koketso from "../assets/Koketso.jpg";


const Tutors =[
    {profileImage:Remofilwe,
        name:"Remofilwe Sekgobela",
        modules:"Accounting 1A/1B",
        bio:"I am Remofilwe Kagiso Sekgobela, founder and CEO of Dripanomics Tutorials, and a former top-performing matric student at Curro Academy Pretoria in 2021. Despite challenges like Covid-19 restrictions and load shedding, I achieved academic excellence, securing a fully paid bursary for 2022-2024. As a dedicated and results-driven educator, I have a proven track record in fostering academic excellence, particularly in accounting. My success lies in providing targeted support to struggling students, facilitating a deeper understanding of complex concepts. I hold distinctions in my BCom in Business Management from the University of Johannesburg, reflecting my commitment to academic achievement. I possess strong communication, conflict management, planning, organizing, and writing skills, making me an ideal candidate for any business or academic opportunity.",
    },

    {profileImage:Koketso,
    name:"Koketso Mathole",
    modules:"Computer Science 1A & Applied Mathematics",
    bio:"Koketso B. Mathole, a fourth-year student at the University of Johannesburg pursuing a BSc in Mathematics in Applied Mathematics and Computer Science, is deeply passionate about problem-solving. With a unique fusion of mathematics and programming, particularly in Java and C++, Koketso turns these subjects into engaging hobbies, unlocking a realm of creativity and exhilarating problem-solving. As a dedicated tutor, Koketso aims to nurture minds, foster a love for learning, and instill confidence in tackling academic challenges, offering an educational journey where each session becomes an opportunity for growth and discovery."
    },

    
]

export default Tutors;